import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from '~/utils/navigation';

export const StyledLink = styled(motion.span).attrs(({ dataAt }) => ({
	'data-at': dataAt
}))`
	a {
		display: block;
	}
`;

const SCALE_09 = { scale: 0.9 };
export const LinkWithPressEffect = ({ children, to, href, target, dataAt, className, onClick }) => {
	return (
		<StyledLink whileTap={SCALE_09}>
			{href && (
				<a href={href} className={className} target={target} data-at={dataAt} onClick={onClick}>
					{children}
				</a>
			)}
			{to && (
				<Link href={to} onClick={onClick} className={className} data-at={dataAt}>
					{children}
				</Link>
			)}
		</StyledLink>
	);
};
